<template>
  <v-flex class="aside-ad mb-7">
    <h3 class="display-48 white--text m-auto">
      מעסיק,
      <br />מחפש
      <br />עובדים?
    </h3>
    <h4 class="display-24 white--text mt-6">
      עשרות אלפי
      <br />מועמדים ביום!
    </h4>
    <DrBtn
      type-btn="rectangle mt-4"
      :go-to-url="`${adminUrl}`"
    >פרסם משרות עכשיו!</DrBtn>
  </v-flex>
</template>


<script>
export default {
  computed: {
    adminUrl() {
      return process.env.adminUrl;
    }
  }
};
</script>


<style scoped>
.aside-ad {
  background: #3e4a54;
  text-align: center;
}
</style>
